<template>
    <div class="container-fluid">
       {{$ml.get('ACTİVATİON_UNDERWAY')}}
    </div>    
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import swal from 'sweetalert'
export default {
    components: {
    },
    name:'activation',
    data (){
        return {
            key:''
        }
    },
    methods:{
        activate(key){
            if(key!=''){
                axios({
                    method:'POST',
                    url:'/activation',
                    baseURL: this.baseUrl,
                    data:{
                        key:key,
                    },
                    withCredentials:true
                }).then((res)=>{
                    
                    if(res.status.code==="0"){
                        
                        swal(res.data.status.desc)
                        this.$router.push('/login')
                    }else{
                        
                        swal(res.data.status.desc)
                        this.$router.push('/login')
                    }
                })
            }else{
                swal(this.$ml.get('VALID_ACTIVATION_CODE'))
            }
        }
    },
    computed:{
        ...mapState([
          'baseUrl'
      ]),
    },
    created(){
        this.key = this.$route.query.key
    },
    mounted(){
        this.activate(this.key)
    }
}
</script>

<style scoped>
    
</style>